/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { Link, useHistory } from 'react-router-dom';

interface Props {
  subtitle: string;
  backLabel?: string;
  backUrl?: string;
  onBack?: () => void;
  showBrandLogo?: boolean;
  hideBackIcon?: boolean;
}

function renderBackLabel(
  history: any,
  hideBackIcon: boolean,
  backLabel?: string,
  backUrl?: string,
  onBack?: () => void
): JSX.Element | null {
  if (!backLabel) {
    return null;
  }

  if (!backUrl) {
    return (
      <h3 id="SimpleHeader_button___back">
        <a className={`${hideBackIcon ? 'hide-back-icon' : 'show-back-icon'}`} onClick={onBack || history.goBack}>
          {backLabel}
        </a>
      </h3>
    );
  }

  return (
    <h3 id="SimpleHeader_button___back">
      <Link to={backUrl} className={`${hideBackIcon ? 'hide-back-icon' : 'show-back-icon'}`}>
        <>{backLabel}</>
      </Link>
    </h3>
  );
}

export default function SimpleHeader({
  subtitle,
  backLabel,
  backUrl,
  onBack,
  showBrandLogo,
  hideBackIcon,
}: Props): JSX.Element {
  const history = useHistory();
  const hideBackIconProp = hideBackIcon || false;

  return (
    <div className="component no-background simple-header-container" id="SimpleHeader_container">
      <div className="component-inner">
        <div className="header-auth-centered">
          <div className="inner">
            {renderBackLabel(history, hideBackIconProp, backLabel, backUrl, onBack)}
            <h1 id="SimpleHeader_title">{subtitle}</h1>
          </div>
        </div>
        {showBrandLogo ? (
          <div className="branding">
            <span />
          </div>
        ) : null}
      </div>
    </div>
  );
}
